"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormMessageIconContainer = exports.FormMessage = void 0;

var _polished = require("polished");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FormMessage = _styledComponents["default"].div.withConfig({
  displayName: "FormMessagestyled__FormMessage",
  componentId: "o1qoaz-0"
})(["--spacingX:24px;--spacingY:18px;--iconReferenceWidth:22px;--iconSpacingX:16px;position:relative;padding:var(--spacingY) var(--spacingX);padding-left:calc(var(--spacingX) + var(--iconReferenceWidth) + var(--iconSpacingX));margin-bottom:16px;border-radius:5px;color:var(--colors-bayoux);border:1.5px solid;text-align:left;line-height:1.5;&::before{content:'';}a{text-decoration:underline;}a,strong{font-weight:500;}", ""], function (props) {
  switch (true) {
    case props.error:
      {
        return (0, _styledComponents.css)(["--iconFill:var(--colors-redPink);background-color:rgb(256,246,246);border-color:rgba(255,74,90,0.5);"]);
      }

    case props.warning:
      {
        return (0, _styledComponents.css)(["--iconFill:#e9b34a;background-color:#fffbf5;border-color:var(--iconFill);"]);
      }

    case props.success:
      {
        return (0, _styledComponents.css)(["--iconFill:var(--colors-darkTurquoise);background-color:#f3fafb;border-color:#01b0bb;"]);
      }

    default:
      {
        return (0, _styledComponents.css)(["--iconFill:var(--colors-irisBlue);background-color:#f7f7fc;border-color:", ";"], function (_ref) {
          var theme = _ref.theme;
          return (0, _polished.transparentize)('0.5', theme.brandPrimary);
        });
      }
  }
});

exports.FormMessage = FormMessage;

var FormMessageIconContainer = _styledComponents["default"].span.withConfig({
  displayName: "FormMessagestyled__FormMessageIconContainer",
  componentId: "o1qoaz-1"
})(["display:block;width:24px;height:24px;position:absolute;left:var(--spacingX);top:var(--spacingY);svg{fill:var(--iconFill);}"]);

exports.FormMessageIconContainer = FormMessageIconContainer;